<template>
<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">
        <img alt="KegTap logo" src="./assets/logo.png" class="img-fluid" id="kegtap-logo-mini" />
        Password reset
      </h5>
    </div>
    <div class="modal-body">
      <div class="text-center mt-3" v-if="loading">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
      <div v-if="!loading">
        <FindUser v-if="currentChallenge === 'find_user'" />
        <p class="text-center" v-if="currentChallenge === 'verify_email'">
          <strong v-if="!verifyEmailErrorMsg">A verification link has been sent to your e-mail address</strong>
          <strong v-if="verifyEmailErrorMsg" class="text-danger">{{verifyEmailErrorMsg}}</strong>
        </p>
        <ResetPassword v-if="currentChallenge === 'passwd'" />
      </div>
    </div>
  </div>
</div>
</template>

<script>
import client from 'api-client';
import FindUser from './FindUser.vue';
import ResetPassword from './ResetPassword.vue';
import { mapState } from 'vuex';

export default {
  name: 'ChallengeManager',
  components: {
    FindUser,
    ResetPassword
  },
  computed: mapState({
    loading: state => state.challengeLoading || state.verifyEmailLoading,
    currentChallenge: state => state.currentChallenge,
    verifyEmailErrorMsg: state => state.verifyEmailErrorMsg
  })
}
</script>
